/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <LoadScreen v-if="mostrarLoader" />
  <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalError v-if="mostrarError" :mostrarError="mostrarError" />

  <ModalBase v-if="mostrarModal">
    <section class="contenedorPrincipal">
      <section>
        <div class="titulo">{{ tituloHeader }}</div>
        <div class="separador"></div>
      </section>

      <div>
        <div class="label">Nombre de la ferretería:</div>
        <input class="inputEditar" type="text" v-model="nombre" />
      </div>

      <div>
        <div class="label">Estado:</div>
        <select class="inputEditar" v-model="estado" @change="cargarCiudades">
          <option value="">Seleccione un estado</option>
          <option v-for="(item, index) in estados" :key="index" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <div>
        <div class="label">Ciudad:</div>
        <select class="inputEditar" v-model="ciudad" :disabled="!estado">
          <option value="">Seleccione una ciudad</option>
          <option
            v-for="(item, index) in ciudadesFiltradas"
            :key="index"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div>
        <div class="label">Dirección:</div>
        <input class="inputEditar" type="text" v-model="domicilio" />
      </div>

      <div>
        <div class="label">Teléfono:</div>
        <input class="inputEditar" type="text" v-model="telefono" maxlength="15" />
      </div>

      <div>
        <div class="label">Correo electrónico:</div>
        <input class="inputEditar" type="email" v-model="correo" maxlength="50" />
      </div>

      <section class="contenedorBotones">
        <Button class="btn-regresar" @click="cancelar">Regresar</Button>
        <Button class="btn-guardar" @click="guardarFerreteria">Guardar</Button>
      </section>
    </section>
  </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import axios from "axios";
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from "../Forms/LoadScreen.vue";

export default {
  components: { Button, ModalBase, ModalExito, ModalError, LoadScreen },
  props: {
    tituloHeader: {
      type: String,
      default: "Editar Ferretería",
    },
    ferreteria: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarLoader: false,
      mostrarModal: true,
      mostrarExito: false,
      mostrarError: false,
      nombre: "",
      estado: "",
      ciudad: "",
      domicilio: "",
      telefono: "",
      correo: "",
      estados: ["Sinaloa", "Sonora", "Chihuahua", "Durango", "Nayarit"],
      ciudadesPorEstado: {
        Sinaloa: [
          "Culiacán",
          "Mazatlán",
          "Los Mochis",
          "Guasave",
          "Navolato",
          "Salvador Alvarado",
          "El Fuerte",
          "Rosario",
          "Escuinapa",
        ],
        Sonora: ["Hermosillo", "Cajeme", "Nogales", "San Luis Río Colorado"],
        Chihuahua: ["Chihuahua", "Ciudad Juárez", "Delicias"],
        Durango: ["Durango", "Gómez Palacio", "Lerdo"],
        Nayarit: ["Tepic", "Bahía de Banderas", "Compostela"],
      },
    };
  },
  computed: {
    ciudadesFiltradas() {
      return this.ciudadesPorEstado[this.estado] || [];
    },
  },
  emits: ["cancelar", "actualizar"],
  methods: {
    cancelar() {
      this.$emit("cancelar");
    },
    cargarCiudades() {
      this.ciudad = "";
    },
    guardarFerreteria() {
      this.mostrarLoader = true;

      const ferreteriaData = {
        nombre: this.nombre,
        estado: this.estado,
        ciudad: this.ciudad,
        domicilio: this.domicilio,
        telefono: this.telefono,
        correo: this.correo,
      };

      axios
        .put(`http://localhost:3000/api/ferreterias/${this.ferreteria.id}`, ferreteriaData)
        .then((response) => {
          console.log("Ferretería actualizada con éxito", response);
          this.mostrarLoader = false;
          this.mostrarExito = true;
          this.$emit("actualizar", ferreteriaData);

          setTimeout(() => {
            this.mostrarExito = false;
            this.mostrarModal = false;
          }, 2000);
        })
        .catch((error) => {
          console.error("Error al actualizar la ferretería:", error);
          this.mostrarLoader = false;
          this.mostrarError = true;
          setTimeout(() => (this.mostrarError = false), 2000);
        });
    },
  },
  watch: {
    ferreteria: {
      immediate: true,
      handler(nueva) {
        if (nueva) {
          this.nombre = nueva.nombre || "";
          this.estado = nueva.estado || "";
          this.ciudad = nueva.ciudad || "";
          this.domicilio = nueva.domicilio || "";
          this.telefono = nueva.telefono || "";
          this.correo = nueva.correo || "";
        }
      },
    },
  },
};
</script>

<style scoped>
.titulo {
  padding: 30px 0px 0px 0px;
  font-size: 30px;
}

.separador {
  border-top: 3px solid #2a428c;
  height: 2px;
  margin-top: 5px;
  margin-bottom: 30px;
}

.contenedorPrincipal {
  margin: 0px 30px;
}

.label {
  margin: 17px 0px 5px;
}

.inputEditar {
  width: 300px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
}

.contenedorBotones {
  display: flex;
  justify-content: space-between;
  max-width: 80%;
  margin: auto;
  padding: 20px 0px 20px;
}
</style>
